import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  overwriteVersionRequest,
  overwriteVersionSuccess,
  overwriteVersionFailure,
} from '../reducers/savedVersions';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/version/`;

function* versionAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;
  const { selectedUserVersion } = state.userProgramsFullReducer;
  const { pathToSaveVersion: pathToVersion } = state.savedVersionsReducer;

  const response = yield call(() =>
    axios({
      method: 'put',
      url: `${API}${selectedUserVersion}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      data: {
        pathToVersion,
      },
    }),
  );
  
  return response;
}

function* workerVersionSaga() {
  try {
    const response = yield call(versionAxios);
    if (response.status === 200) {
      yield put(overwriteVersionSuccess(response.data.data));
    }
    if (response.status === 400) {
      yield put(overwriteVersionFailure('Content does not exist'));
    }
  } catch (error) {
    yield put(overwriteVersionFailure(error));
  }
}

export function* watcherVersionSaga() {
  yield takeLatest(overwriteVersionRequest().type, workerVersionSaga);
}
